import React from 'react';

const Error = () => {
    return (
        <div className="">Oops.. Nothing found here.</div>
    )
}

export default Error